import {
  calendlyOAuthUrl,
  ghlOAuthUrl,
  integrationsSettings,
  integrationsStatus,
} from '@/constants/endpoints';

import { APIClient } from '@/lib/ApiClient';

const apiClient = new APIClient();

/**
 * Get status of all integrations
 */
export function getIntegrationsStatus() {
  return apiClient.get(integrationsStatus, null, true);
}

/**
 * Get OAuth URL for Calendly connection
 */
export function getCalendlyOAuthUrl() {
  return apiClient.get(calendlyOAuthUrl, null, true);
}

/**
 * Get OAuth URL for GHL Calendar connection
 */
export function getGhlOAuthUrl() {
  return apiClient.get(ghlOAuthUrl, null, true);
}

/**
 * Save integration settings (generic function)
 */
export function saveIntegrationSettings(integration, settings) {
  return apiClient.create(
    integrationsSettings,
    {
      integration,
      settings,
    },
    true
  );
}
